var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "110px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "三方SDK类型", prop: "sdk_type_id" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.formData.sdk_type_id,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "sdk_type_id", $$v)
                    },
                    expression: "formData.sdk_type_id"
                  }
                },
                _vm._l(_vm.otherSdkTypeList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.sdk_name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "SDK版本", prop: "file_version" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "版本" },
                model: {
                  value: _vm.formData.file_version,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "file_version", $$v)
                  },
                  expression: "formData.file_version"
                }
              })
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%", height: "auto" } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: "上传文件", prop: "file" }
                },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "auto-upload": false,
                        "on-change": _vm.handleChange,
                        "file-list": _vm.fileList,
                        "on-exceed": _vm.handleExceed,
                        limit: 1,
                        "before-upload": _vm.beforeUpload,
                        name: "file",
                        accept: ".keystore"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "file",
                          fn: function(ref) {
                            var file = ref.file
                            return _c("div", {}, [
                              _c(
                                "span",
                                { staticClass: "el-upload-list__item-name" },
                                [
                                  _c("i", { staticClass: "el-icon-document" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(file.name + "-") +
                                      _vm._s(
                                        _vm.$utils.formatFileSize(file.size)
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "el-upload-list__item-status-label"
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-upload-success el-icon-circle-check"
                                  })
                                ]
                              ),
                              _c("i", {
                                staticClass: "el-icon-close",
                                on: {
                                  click: function($event) {
                                    return _vm.handleRemove(file)
                                  }
                                }
                              })
                            ])
                          }
                        }
                      ])
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [
                          _vm._v("请上传大小不超过"),
                          _c("b", { staticStyle: { color: "#f56c6c" } }, [
                            _vm._v("100MB")
                          ]),
                          _vm._v("格式为"),
                          _c("b", { staticStyle: { color: "#f56c6c" } }, [
                            _vm._v("keystore")
                          ]),
                          _vm._v("的文件")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "store_pass", prop: "params.store_pass" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "store_pass" },
                model: {
                  value: _vm.formData.params.store_pass,
                  callback: function($$v) {
                    _vm.$set(_vm.formData.params, "store_pass", $$v)
                  },
                  expression: "formData.params.store_pass"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "alias", prop: "params.alias" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "alias" },
                model: {
                  value: _vm.formData.params.alias,
                  callback: function($$v) {
                    _vm.$set(_vm.formData.params, "alias", $$v)
                  },
                  expression: "formData.params.alias"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "key_pass", prop: "params.key_pass" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "key_pass" },
                model: {
                  value: _vm.formData.params.key_pass,
                  callback: function($$v) {
                    _vm.$set(_vm.formData.params, "key_pass", $$v)
                  },
                  expression: "formData.params.key_pass"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "warning", round: "" },
              on: {
                click: function($event) {
                  return _vm.rewriteClearData(false)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "", loading: _vm.reqLoading },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit("ruleForm")
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }